
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20","data-token-name":"history"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.636 14.67l2.499-2.5V8.002m1.663-2.292L8.465 3.004 12.215.71","stroke":"currentColor","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M3.09 15.5A8.198 8.198 0 108.517 3.03M5.71 4.114a8.308 8.308 0 00-2.536 2.447M1.947 9.584a8.51 8.51 0 00.108 3.522","stroke":"currentColor","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    